import { lazy } from 'react'

export const ComplianceDashboardPage = lazy(() =>
  import('@/features/compliance/pages/ComplianceDashboardPage').then((m) => ({ default: m.ComplianceDashboardPage }))
)
export const KonarPage = lazy(() =>
  import('@/features/compliance/pages/KonarPage').then((m) => ({ default: m.KonarPage }))
)
export const ReviewCaseDetailPage = lazy(() =>
  import('@/features/compliance/pages/konar/ReviewCaseDetailPage').then((m) => ({ default: m.ReviewCaseDetailPage }))
)
export const KonarRuleDetailPage = lazy(() =>
  import('@/features/compliance/pages/konar/RuleDetailPage').then((m) => ({ default: m.RuleDetailPage }))
)
export const KonarListDetailPage = lazy(() =>
  import('@/features/compliance/pages/konar/ListDetailPage').then((m) => ({ default: m.ListDetailPage }))
)
export const ScorecardsPage = lazy(() =>
  import('@/features/compliance/pages/ScorecardsPage').then((m) => ({ default: m.ScorecardsPage }))
)
export const ScorecardDetailPage = lazy(() =>
  import('@/features/compliance/pages/scorecards/ScorecardDetailPage').then((m) => ({ default: m.ScorecardDetailPage }))
)
export const ScorecardCreatePage = lazy(() =>
  import('@/features/compliance/pages/scorecards/ScorecardCreatePage').then((m) => ({ default: m.ScorecardCreatePage }))
)
export const VerificationsPage = lazy(() =>
  import('@/features/compliance/pages/VerificationsPage').then((m) => ({ default: m.VerificationsPage }))
)
export const BusinessVerificationDetailPage = lazy(() =>
  import('@/features/compliance/pages/verifications/BusinessVerificationDetailPage').then((m) => ({ default: m.BusinessVerificationDetailPage }))
)
export const IndividualVerificationDetailPage = lazy(() =>
  import('@/features/compliance/pages/verifications/IndividualVerificationDetailPage').then((m) => ({ default: m.IndividualVerificationDetailPage }))
)
export const FormBuilderPage = lazy(() =>
  import('@/features/compliance/pages/konar/FormBuilderPage').then((m) => ({ default: m.FormBuilderPage }))
)
export const SARPage = lazy(() =>
  import('@/features/compliance/pages/SARPage').then((m) => ({ default: m.SARPage }))
)
export const SARCaseDetailPage = lazy(() =>
  import('@/features/compliance/pages/sar/SARCaseDetailPage').then((m) => ({ default: m.SARCaseDetailPage }))
)
export const SARCaseCreatePage = lazy(() =>
  import('@/features/compliance/pages/sar/SARCaseCreatePage').then((m) => ({ default: m.SARCaseCreatePage }))
)
